import { useEffect, useState } from 'react';
import MeetingsStatisticsAPI, { VisitsInsightsResponse } from '../../../api/MeetingsStatisticsAPI';

type TimeRange = { start: string; end: string };

export function useVisitsInsights(timeRange: TimeRange): {
  data: VisitsInsightsResponse | null;
  loading: boolean;
  error: boolean;
} {
  const [data, setData] = useState<VisitsInsightsResponse | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setError(false);
    const fetchData = async () => {
      try {
        const res = await MeetingsStatisticsAPI.getUpcomingVisits({
          startTime: timeRange.start,
          endTime: timeRange.end,
        });
        if (!cancelled) {
          setData(res.data ?? null);
          setError(!res.data);
        }
      } catch {
        if (!cancelled) {
          setData(null);
          setError(true);
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    };
    fetchData();
    return () => {
      cancelled = true;
    };
  }, [timeRange.start, timeRange.end]);

  return { data, loading, error };
}
